import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-budget-cap-management',
  templateUrl: './budget-cap-management.component.html',
  styleUrls: ['./budget-cap-management.component.scss']
})
export class BudgetCapManagementComponent {
  @Output() back = new EventEmitter<void>();
}
